import React from 'react'

interface Props {
  label: string
  status: string
}

const STATUS_CONFIG: Record<string, { className: string; label: string }> = {
  DRAFT: { className: 'chipDraft', label: 'Waiting for Review' },
  APPROVED: { className: 'chipApproved', label: 'Approved' },
  REJECTED: { className: 'chipRejected', label: 'Rejected' },
}

export default function OverrideHeaderChips({ label, status }: Props) {
  const config = STATUS_CONFIG[status] ?? {
    className: 'chipDraft',
    label: status,
  }
  return (
    <span className="chips">
      <span className="chip chipType">{label}</span>
      <span className={`chip ${config.className}`}>
        <span className="chipDot" />
        {config.label}
      </span>
    </span>
  )
}
